module.exports = __webpack_public_path__ + "static/media/bg-text.9c1ce257.png";